import React, { useEffect } from 'react';

// assets

// services

// props

// components
import { DefaultButton, Dropdown, IDropdownOption, Label, Panel, PanelType, PrimaryButton, Spinner, SpinnerSize, Stack, TagPicker, Text, TextField } from '@fluentui/react';
import { faCheck, faXmarkCircle } from '@fortawesome/pro-light-svg-icons';
import { useStore } from '../../../../../stores/root';
import { ISalesTeamMemberResourceShort } from '../../../../../props/users/team';
import { TeamMemberService } from '../../../../../services/users/team';

interface IDeleteTeamMemberFormProps {
    teamMember: ISalesTeamMemberResourceShort;
    onDismissed(refresh?: boolean): void;
}

const DeleteTeamMemberForm: React.FC<IDeleteTeamMemberFormProps> = (props: IDeleteTeamMemberFormProps) => {
    const { banner } = useStore();
    const [submitting, setSubmitting] = React.useState<boolean>(false);

    const _onSubmit = async () => {
        try {
            setSubmitting(true);
            await TeamMemberService.delete(props.teamMember.id);

            banner.add({
                key: 'delete_teamMember_success',
                variant: 'success',
                icon: faCheck,
                text: `TeamMember "${props.teamMember.team.name}" deleted successfully`
            });
            props.onDismissed(true);
        } catch (e) {
            setSubmitting(false);
        }
    }

    return <Panel headerText={"Delete TeamMember"}
        isOpen={true}
        type={PanelType.medium}
        onDismiss={() => props.onDismissed(false)}
        isFooterAtBottom={true}
        onRenderFooterContent={() => {
            return <Stack horizontal tokens={{ childrenGap: 10 }}>
                {
                    !submitting ? (
                        <>
                            <PrimaryButton text={"Delete"} onClick={_onSubmit} />
                            <DefaultButton text={"Cancel"} onClick={() => { props.onDismissed(false) }} />
                        </>
                    ) : null
                }
                {submitting ? <Spinner size={SpinnerSize.medium} labelPosition={"right"} label={"Deleting teamMember ..."} /> : null}
            </Stack>;
        }}>
        <Stack tokens={{ childrenGap: 15 }} styles={{ root: { marginTop: 20 } }}>
            <Text>Are you sure you want to delete teamMember with details below?</Text>
            <Stack.Item>
                <Label>Name</Label>
                <Text>{props.teamMember.sales.name}</Text>
            </Stack.Item>
        </Stack>
    </Panel>
};

export default DeleteTeamMemberForm;
